import React, { useEffect, useState } from 'react';
import Modal from 'react-responsive-modal';
import {
	Form,
	FormGroup,
	Label,
	Col,
} from 'reactstrap';
import Select from 'react-select';
import { Post } from '../../../../function/Koneksi';

const ModalDetailKategoriSurat = ({ data, optionData, setAlert, isOpen, setIsOpen, setStatusRefresh}) => {

	const frmDex = {
		uuid: '',
		id_konfigurasi_nomor: '',
		id_jenis: '',
	}

	const initFormData = {
		kategoriDetail: optionData.kategoriDetail,
		frmListJenisSurat: optionData.frmListJenisSurat,
		jenisSuratStat: null,
		status: {
			form: false,
			btnForm: false,
			btnAksi: [],
		},
		show: false,
		basicTitle: "",
		basicType: "default",
		pesanAlert: "",
	}

	const [formData, setFormData] = useState(initFormData)
	const [dt, setDt] = useState(data ? data : frmDex)
	const [draggable, setDraggable] = useState({
		isDown: false,
		startY: null,
		scrollUp: null,
	})

	useEffect(() => {
		if (document.getElementById("modalForm")) {
			document.getElementById("modalForm").reset()
		}
		setDt(data ? data : frmDex)
		setFormData(data ? {
			...initFormData,
			status: optionData.status,
		} : initFormData)
	}, [isOpen])




	const changeSelectValue = (e, dtVal, formVal) => {
		if(e){
			setDt({
				...dt,
				[dtVal]: e.value,
			})
	
			setFormData({
				...formData,
				[formVal]: e,
			})
		}
		else{
			setDt({
				...dt,
				[dtVal]: '',
			})
	
			setFormData({
				...formData,
				[formVal]: null,
			})
		}
	};

	const simpan = (e) => {
		e.preventDefault();
		setAlert({
			loadingPreview: true
		})

		let bodyRaw = {
			...dt,
			id_konfigurasi_nomor: formData.kategoriDetail.uuid,
		}

		let psn = "";
		let resstat = 204;
		let metode = "create";
		if (bodyRaw.uuid === "") {
			psn = "Tambah";
			resstat = 201;
			bodyRaw.uuid = null;
		} else {
			psn = "Ubah";
			resstat = 200;
			metode = "update";
		}

		if(formData.jenisSuratStat){
			Post("konfigurasi-nomor/detail/" + metode, bodyRaw.uuid, bodyRaw,res => {
				setFormData({
					...formData,
					status: {
						...formData.status,
						btnForm: false,
						form: false,
					}
				})
				setIsOpen(false)
				if (res.status === resstat) {
					setAlert({
						loadingPreview: false
					})

					const alertData = {
						show: true,
						basicType: "success",
						basicTitle: "Data Detail Kategori Surat",
						pesanAlert: "Berhasil " + psn + " Data",
						successAlert: true,
					}
					setAlert(alertData)
				} else if(res.status === 422) {
					let cekResp = res.data.results.split(' ').some(function(w){return w === 'already'})

					setAlert({
						loadingPreview: false
					})

					const alertData = {
						show: true,
						basicType: "warning",
						basicTitle: "Data Detail Kategori Surat",
						pesanAlert: cekResp?'Jenis surat sudah digunakan':'Data Tidak Lengkap',
					}
					setAlert(alertData)
				} else {
					setAlert({
						loadingPreview: false
					})

					const alertData = {
						show: true,
						basicType: "danger",
						basicTitle: "Data Detail Kategori Surat",
						pesanAlert: "Gagal " + psn + " Data"
					}
					setAlert(alertData)
				}
	
				// Refresh list
				setStatusRefresh(true)
			});
		}
		else{
			setAlert({
				loadingPreview: false
			})

			const alertData = {
				show: true,
				basicType: "warning",
				basicTitle: "Data Detail Kategori Surat",
				pesanAlert: "Data tidak lengkap!"
			}
			setAlert(alertData)
		}
	};

	return (
		<Modal
			classNames={{ overlay: 'card-scrollable' }}
			open={isOpen}
			onClose={() => {
				setIsOpen(false)
			}}
			closeOnEsc={false}
			closeOnOverlayClick={true}
			style={{
				maxwidth: 'unset'
			}}
		>
			<Form
				id="modalForm"
				data-testid="form-create"
				className="theme-form"
				onSubmit={simpan}
			>
				<div
					onMouseDown={(e) => {
						let slider = document.querySelector('.card-scrollable');
						setDraggable({
							isDown: true,
							startY: e.pageY - slider.offsetTop,
							scrollUp: slider.scrollTop,
						})
					}}
					onMouseLeave={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseUp={() => {
						setDraggable({
							...draggable,
							isDown: false
						})
					}}
					onMouseMove={(e) => {
						e.preventDefault();

						let slider = document.querySelector('.card-scrollable');

						if (!draggable.isDown) {
							return;
						}

						const y = e.pageY - slider.offsetTop;
						const startY = draggable.startY;
						const walk = y - startY;
						slider.scrollTop = draggable.scrollUp - walk;
					}}
				>
				<div className="modal-header">
					<h5 className="modal-title">{dt.uuid == '' ? 'Tambah' : 'Edit'} Detail Kategori Surat {formData.kategoriDetail?formData.kategoriDetail.label:''}</h5>
				</div>
				<div className="modal-body">
					<input
						className="form-control"
						id="uuid"
						type="hidden"
						placeholder=""
						defaultValue={dt.uuid}
					/>
					<FormGroup className="row">
						<Label
						className="col-sm-3 col-form-label"
						htmlFor="inputEmail3"
						>
						Jenis Surat{" "}
						</Label>
						<Col sm="9">
						<Select
							classNamePrefix="select"
							onChange={e => {
								changeSelectValue(e,'id_jenis','jenisSuratStat');
							}}
							defaultValue={formData.jenisSuratStat}
							value={formData.jenisSuratStat}
							name="id_jenis"
							options={formData.frmListJenisSurat}
							placeholder="Pilih Jenis Surat"
							isClearable
						/>
						</Col>
					</FormGroup>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn btn-warning"
						onClick={() => {
							// Tutup modal
							setFormData({
								...formData,
								status: {
									...formData.status,
									form: false,
								}
							})
							setIsOpen(false)
						}}
					>
						Tutup
					</button>
					<button
						data-testid="btnSubmitCreate"
						type="submit"
						className="btn btn-primary-custom"
						disabled={formData.status.btnForm}
					>
						Simpan
					</button>
				</div>
				</div>
			</Form>
		</Modal>
	);
}

export default ModalDetailKategoriSurat;
